import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import ContactoTwo from "../../components/contact-distribuidor/ContactTwo";


function Distribuidor(){
    useEffect(() => {
            window.scrollTo(0,0)
        },[])
    return(
        <Layout>
            <NavBar/>
            <div>
                <ContactoTwo/>
            </div>
            <Footer/>
        </Layout>
    )
}export default Distribuidor;